/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_S4Inputs */

const en_tut_wakil_s4 = /** @type {(inputs: Tut_Wakil_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch what it has answered under **Aktivitas Wakil Digital** in the same dialog.`)
};

const id_tut_wakil_s4 = /** @type {(inputs: Tut_Wakil_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantau apa saja yang sudah ia jawab di bagian **Aktivitas Wakil Digital** pada dialog yang sama.`)
};

/**
* | output |
* | --- |
* | "Watch what it has answered under **Aktivitas Wakil Digital** in the same dialog." |
*
* @param {Tut_Wakil_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_s4 = /** @type {((inputs?: Tut_Wakil_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_s4(inputs)
	return en_tut_wakil_s4(inputs)
});